module.exports = __webpack_public_path__ + "images/cabbage-f840fb927407aaefb26fbf35fab9adec.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/cabbage.jpeg
// module id = 227
// module chunks = 0